import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';
import { useState } from 'react';
import { ThemeProvider } from './design/ThemeProvider.js';
import { AuthProvider } from './lib/auth/AuthProvider.js';
import { createQueryClient } from './lib/query-client.js';
import { router } from './routes/router.js';

/**
 * Provider composition. The order is not arbitrary:
 *
 *   ThemeProvider   — outermost, because everything below may render antd
 *   QueryClient     — AuthProvider is a query, so it needs this above it
 *   AuthProvider    — the router's guards read the session
 *   RouterProvider  — innermost
 *
 * The client is created in `useState` rather than at module scope so that each
 * mounted App owns its own cache. At module scope, two tests in one file would
 * share cached data and the second would pass for the wrong reason.
 */
export function App() {
  const [queryClient] = useState(createQueryClient);

  return (
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <RouterProvider router={router} />
        </AuthProvider>
      </QueryClientProvider>
    </ThemeProvider>
  );
}
